const qs = require('qs')
import get from 'lodash/get'
class PromoStripe {
  static getPromoCode(queryParams: string) {
    const parsedParams = qs.parse(queryParams)
    const promoCode = get(parsedParams, '?promo', null) || get(parsedParams, 'promo', null)
    const rewardCode = get(parsedParams, '?reward', null) || get(parsedParams, 'reward', null)
    const saleCode = get(parsedParams, '?sale', null) || get(parsedParams, 'sale', null)
    const dcCode = get(parsedParams, '?dcparam', null) || get(parsedParams, 'dcparam', null)
    return promoCode || rewardCode || saleCode || dcCode
  }
}

export default PromoStripe
